import Moment from 'moment'

export function convertDateFromApi(date, format = 'DD.MM.YY HH:mm'){
    return Moment(date,'YYYY-MM-DDTHH:mm:ss ZZ').format(format)
}

export function convertDateFromDb(date){
    return Moment(date,'YYYY-M-D HH:mm:ss').format('DD.MM.Y HH:m')
}
